export default "__VITE_ASSET__DDqA8dK8__"